import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Modal from './Modal';
import ProgressButton from '../Buttons/Progress';
import Button from '@material-ui/core/Button';
import { withNamespaces } from 'react-i18next';
import combineStyles from '../../../utils/combineStyles';
import ButtonStyles from '../../../styles/button';
import TypographyStyles from '../../../styles/typography';
import classnames from 'classnames';
import OutlinedSelectInput from '../Inputs/OutlinedSelect';

import { AppContext } from '../../../AppProvider';

import { Formik, FastField } from 'formik';
import Grid from '@material-ui/core/Grid';

const styles = theme => ({
  titleContainer: {
    marginBottom: [theme.spacing.unit * 4.125, '!important'],
    position: 'relative'
  },
  title: {
    fontWeight: ['bold', '!important']
  }
});

export class TagShipmentDocumentType extends Component {
  static propTypes = {
    onSave: PropTypes.func.isRequired
  };

  _handleOnSave = values => {
    this.props.onSave(values);
  };

  render() {
    const {
      referenceData: { shipmentDocumentTypes }
    } = this.context.globalProps;
    const {
      classes,
      t,
      isSubmitting,
      shipmentDocumentTypeId,
      onClose
    } = this.props;

    return (
      <Formik
        enableReinitialize={true}
        validateOnChange={false}
        validateOnBlur={false}
        initialValues={{
          shipmentDocumentTypeId
        }}
        onSubmit={async values => {
          await this._handleOnSave(values);
        }}
        onReset={() => {
          onClose();
        }}
        render={({
          values,
          handleChange,
          handleSubmit,
          handleReset,
          dirty
        }) => (
          <Modal
            open={true}
            classes={{
              root: classes.modalRoot,
              footer: classes.modalFooter
            }}
            body={
              <Fragment>
                <div className={classes.titleContainer}>
                  <p className={classnames(classes.headline6, classes.title)}>
                    {`${
                      !shipmentDocumentTypeId ? t('Add Tag') : t('Edit Tag')
                    }`}
                  </p>
                </div>
                <Grid container spacing={16}>
                  <Grid item xs={12}>
                    <FastField
                      name="shipmentDocumentTypeId"
                      onChange={handleChange}
                      render={({ field, form }) => {
                        return (
                          <OutlinedSelectInput
                            label={t('Select Tag')}
                            value={values.shipmentDocumentTypeId}
                            options={shipmentDocumentTypes}
                            field={field}
                            form={form}
                          />
                        );
                      }}
                    />
                  </Grid>
                </Grid>
              </Fragment>
            }
            footer={
              <Fragment>
                <Button
                  className={classes.button}
                  onClick={handleReset}
                  color={'primary'}
                  classes={{ label: classes.buttonLabel }}
                >
                  {t('Cancel')}
                </Button>
                <ProgressButton
                  onClick={handleSubmit}
                  className={classes.button}
                  classes={{
                    disabled: classes.buttonDisabled,
                    label: classes.buttonLabel
                  }}
                  color={'primary'}
                  disabled={!dirty || isSubmitting}
                  isSubmitting={isSubmitting}
                >
                  {shipmentDocumentTypeId ? t('Save') : t('Add')}
                </ProgressButton>
              </Fragment>
            }
          />
        )}
      />
    );
  }
}

TagShipmentDocumentType.contextType = AppContext;

const translatedTagShipmentDocumentType = withNamespaces()(
  TagShipmentDocumentType
);
export default withStyles(
  combineStyles(styles, ButtonStyles, TypographyStyles)
)(translatedTagShipmentDocumentType);
